"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceRootAdapter = void 0;
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
// @ts-ignore
var SourceRootAdapter = /** @class */ (function (_super) {
    __extends(SourceRootAdapter, _super);
    function SourceRootAdapter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.readonly = false;
        return _this;
    }
    Object.defineProperty(SourceRootAdapter.prototype, "value", {
        get: function () {
            return this.entity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceRootAdapter.prototype, "type", {
        get: function () {
            return this.entity.meta.type.jstype;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceRootAdapter.prototype, "isList", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceRootAdapter.prototype, "displayValue", {
        get: function () {
            return this.entity.toString();
        },
        enumerable: false,
        configurable: true
    });
    SourceRootAdapter.prototype.toString = function () {
        return this.entity.meta.type.fullName + "|" + this.entity.meta.id;
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)(Object),
        __metadata("design:type", Object)
    ], SourceRootAdapter.prototype, "entity", void 0);
    SourceRootAdapter = __decorate([
        vue_property_decorator_1.Component
    ], SourceRootAdapter);
    return SourceRootAdapter;
}(vue_1.default));
exports.SourceRootAdapter = SourceRootAdapter;
